import styled from '@emotion/styled';
import { MenuItem as _MenuItem, Select, Typography, useMediaQuery } from '@material-ui/core';
import { createElement, FC } from 'react';

import theme from '../../../../theme';
import { gridLayoutContainer, gridLayoutItem } from '../../../styleUtility/gridLayout';
import mq from '../../../styleUtility/mediaquery';
import { InputtingCreativeFormatsFilter } from '../../../types/InputtingCreativeFormatsFilter';
import CreativeFormatNetworkIcon from '../CreativeFormatNetworkIcon';
import CreativeFormatPlacementLabel from '../CreativeFormatPlacementLabel';

type Props = {
  isDisabled?: boolean;
  inputtingCreativeFormatsFilter: InputtingCreativeFormatsFilter;
  selectedPlacementIndex: ReadonlyArray<string | null> | null;
  onChangeSelectedNetworksAndPlacements: (value: string) => void;
  className?: string;
};

const SelectNetworksAndPlacements: FC<Props> = ({
  isDisabled = false,
  inputtingCreativeFormatsFilter,
  selectedPlacementIndex,
  onChangeSelectedNetworksAndPlacements,
  className,
}) => {
  const isPC = useMediaQuery(`(min-width:${theme.breakpoints.values['lg']}px)`);
  return (
    <Selects
      disabled={isDisabled}
      value={selectedPlacementIndex && selectedPlacementIndex.length ? selectedPlacementIndex : 'all'}
      onChange={(e) => onChangeSelectedNetworksAndPlacements(`${e.target.value}`)}
      className={className}
    >
      {[
        <MenuItem key={`networksAndPlacement-all`} value={'all'}>
          All
        </MenuItem>,
        ...inputtingCreativeFormatsFilter.networksAndPlacements.map((networksAndPlacement, index) => (
          <MenuItem key={`${index}-${networksAndPlacement.placement.id}`} value={index}>
            <NetworkAndPlacement>
              <NetworkIcon network={networksAndPlacement.network} size={isPC ? 24 : 20} />
              <PlacementName>
                <Typography>
                  <CreativeFormatPlacementLabel placement={networksAndPlacement.placement} />
                </Typography>
              </PlacementName>
            </NetworkAndPlacement>
          </MenuItem>
        )),
      ]}
    </Selects>
  );
};

const Selects = styled(Select)({
  width: '100%',
});

const NetworkAndPlacement = styled('div')(
  gridLayoutContainer({
    columns: ['40px', 'auto'],
    rows: ['auto'],
    areas: [['network', 'placement']],
    alignItems: 'center',
  }),
);

const MenuItem = styled(_MenuItem)({
  [mq('sp')]: {
    minHeight: '40px',
  },
});

const NetworkIcon = styled(CreativeFormatNetworkIcon)(gridLayoutItem('network', { justifySelf: 'center' }));

const PlacementName = styled('div')(gridLayoutItem('placement'));

export default SelectNetworksAndPlacements;
